/**
 * What kind of page a path is, in generic words: "compound_page", "tool", "guide" and so on.
 *
 * The advertising pixels (Meta, Reddit) and their server-side mirrors get this instead of compound or condition names
 * (lib/analytics.ts). California fined Healthline $1.55 million in 2025 over article titles that suggested a
 * diagnosis being sent to ad trackers; a URL or event field such as "retatrutide" or "weight-loss" is the same kind of
 * signal. The GA4 affiliate_click event uses it as the placement when a click names none.
 */
const RULES: [RegExp, string][] = [
  [/^\/$/, "home"],
  [/^\/(compound|nootropic)\/[^/]+/, "compound_page"],
  [/^\/(side-effects|alternatives-to|protocol)\/[^/]+/, "compound_page"],
  [/^\/(tools|embed)(\/|$)/, "tool"],
  [/^\/(guides|best|goal)(\/|$)/, "guide"],
  [/^\/blog(\/|$)/, "article"],
  [/^\/compare\/[^/]+/, "comparison"],
  [/^\/(compare|peptide-prices|buy|coupons|deals)(\/|$)/, "price_page"],
  [/^\/(vendor|vendors|best-peptide-vendors|best-vendors)(\/|$)/, "vendor_page"],
  [/^\/(stack|stacks)(\/|$)/, "stack_page"],
  [/^\/(lp|welcome)(\/|$)/, "landing_page"],
];

export function pageCategory(pathname: string): string {
  const path = (pathname || "/").split(/[?#]/)[0] || "/";
  for (const [rule, category] of RULES) if (rule.test(path)) return category;
  return "page";
}

/**
 * The compound a page is about, from its path, for the GA4 affiliate_click event. Empty on pages that are not about
 * one compound (a vendor's coupon page, the homepage, a blog post).
 */
const COMPOUND_PATH =
  /^\/(?:compound|nootropic|buy|protocol|side-effects|alternatives-to|guides\/dosage|tools\/reconstitution|lp\/compare|coupons)\/([^/?#]+)/;

export function compoundSlugFromPath(pathname: string): string {
  if (/^\/coupons\/vendor(\/|$)/.test(pathname)) return "";
  const match = (pathname || "").match(COMPOUND_PATH);
  if (!match) return "";
  try {
    return decodeURIComponent(match[1]).toLowerCase();
  } catch {
    return match[1].toLowerCase();
  }
}
